import { SLIDES } from "../../content/resources";
import { Page } from "../../layout/Page";
import { Section } from "../../ui/Section";

/**
 * The old site's `/slides`: the 33 concept-slide images as a captioned
 * grid, verbatim captions in the old carousel's order. A plain responsive
 * grid - the Lightbox from B2 Task 5/6 can upgrade this later without
 * changing the content module.
 */
export function SlidesPage() {
  return (
    <Page title="Slides" heading="Slides">
      <Section>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SLIDES.map((slide) => (
            <figure
              key={slide.src}
              className="overflow-hidden rounded-lg border border-hairline bg-card"
            >
              <img
                src={slide.src}
                alt={slide.caption}
                loading="lazy"
                className="aspect-video w-full bg-ivory-deep object-contain"
              />
              <figcaption className="p-3 text-xs text-ink-soft">
                {slide.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </Section>
    </Page>
  );
}
